<div id="biuwer-container" style="width: 88vw; height: 88vh;"></div>

<div class="custom-modal-backdrop" *ngIf="showModal">
  <div class="custom-modal">
    <h2>Bienvenido al nuevo panel de Informes.</h2>
    <p>¿Buscas reportes para tu departamento financiero?</p>
    <p>Listado de reservas, precio medio de reserva, facturación, etc.</p>
    <p>Accede a toda la información que necesitas, ¡en un único lugar!</p>
    <p>Puedes descargar cualquier informe en el formato que elijas clicando sobre las opciones de cada tarjeta.</p>
    <button mat-button color="#F85F1F" (click)="showModal = false">Cerrar</button>
  </div>
</div>